import styled from 'styled-components'
import Button from 'components/Button'
import { Link } from 'react-router-dom'
import { LazyLoadImage } from 'react-lazy-load-image-component'

const specialTagBackgrounds = {
  fast: 'linear-gradient(to right top, #d658e8, #c745ec, #b431f2, #9d1cf8, #7f00ff)',
  sale: 'linear-gradient(to right top, #ff4b2b, #ff453e, #ff424e, #ff405d, #ff416c)',
  top: 'linear-gradient(to right top, #b2de00, #40bd00)',
  last: 'linear-gradient(84.78deg, #FF7E00 0%, #FF2000 100%)',
  gift: 'linear-gradient(84.78deg, #162131 0%, #162139 100%)',
  best: 'linear-gradient(to right top, #ffc94b, #ffb73a, #ffa52c, #ff9221, #ff7f17)',
}

export const ItemImageContainer = styled.div`
  width: 100%;
  height: ${props => (props.onlyPicture ? '100%' : '192px')};
  ${props =>
    props.onlyPicture
      ? 'display: flex; justify-content: center; align-items: center;'
      : ''}
  margin-bottom: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  @media screen and (min-width: 1100px) {
    height: 142px;

    img {
      width: 130px;
      height: 130px;
      object-fit: contain;
    }
  }

  @media screen and (max-width: 500px) {
    height: ${props => (props.onlyPicture ? '100%' : '183px')};
  }
  @media screen and (max-width: 450px) {
    height: ${props => (props.onlyPicture ? '100%' : '160px')};
  }
  @media screen and (max-width: 430px) {
    height: ${props => (props.onlyPicture ? '100%' : '149px')};
  }
  @media screen and (max-width: 410px) {
    height: ${props => (props.onlyPicture ? '100%' : '139px')};
  }
  @media screen and (max-width: 390px) {
    height: ${props => (props.onlyPicture ? '100%' : '129px')};
  }
  @media screen and (max-width: 370px) {
    height: ${props => (props.onlyPicture ? '100%' : '119px')};
  }
  @media screen and (max-width: 350px) {
    height: ${props => (props.onlyPicture ? '100%' : '108px')};
  }
  @media screen and (max-width: 330px) {
    height: ${props => (props.onlyPicture ? '100%' : '100px')};
  }
`

export const ProductImage = styled(LazyLoadImage)`
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 0;
  ${props =>
    props.isOutOfStock &&
    `
    filter: grayscale(1);
    opacity: 0.6;
  `}
`
export const TagButton = styled.button`
  background: ${props => props.background};
`

export const WishlistButton = styled.button`
  background-color: white;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
`

export const SpecialTagContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: space-between;
  top: 0.3rem;
  right: 0.3rem;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 1099px) {
    height: 1.56rem;
    margin-bottom: 0.6rem;
  }
`

export const SpecialTag = styled.div`
  border-radius: 3.125rem;
  width: 1.5rem;
  height: 1.5rem;
  transition: width 0.5s ease, margin-left 0.5s ease;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: white;
  font-family: ${props => props.theme.font.family.medium};
  background-image: ${props => specialTagBackgrounds[props.type] || 'none'};

  &:hover {
    width: ${props => props.expandedWidth};
  }

  svg {
    width: 0.87rem;
    height: 0.87rem;
    flex-shrink: 0;
    margin-left: 0.3rem;
    margin-bottom: 0.1rem;
  }

  span {
    font-size: 0.75rem;
    font-weight: 600;
    margin: 0 0.37rem;
    opacity: 0;
    transition: opacity 0.4s ease, transform 0.4s ease;
    white-space: nowrap;
  }

  &:hover span {
    opacity: 1;
  }

  @media screen and (max-width: 1099px) {
    &:hover {
      width: ${props => props.expandedWidth || '7rem'};
    }

    span {
      font-size: 0.6rem;
    }
  }
`

export const SalePercentage = styled.div`
  position: absolute;
  bottom: ${props => (props.productItem ? '-10px' : '0px')};
  font-size: 12px;
  left: ${props => (props.productItem ? 0 : '')};
  right: ${props => (props.productItem ? '' : '150px')};
  background: linear-gradient(
    to right top,
    #ff4b2b,
    #ff453e,
    #ff424e,
    #ff405d,
    #ff416c
  );
  color: white;
  padding: 2px 8px;
  border-radius: 20px;
  font-weight: bold;
  letter-spacing: 0.8px;
`

export const CardContainer = styled.div`
  background: #f7fafc;
  margin-top: 20px;
  border-radius: 10px;
  padding: 14px;
  border: 1px solid red;
`

export const ItemPrice = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-bottom: 7px;

  img {
    margin-right: 6px;
  }

  .out-of-stock {
    font-size: 13px;
    padding-bottom: 5px;
  }

  p,
  .price-icon {
    font-size: 18px;
    font-family: ${props => props.theme.font.family.medium};
    font-weight: bolder;
    border-radius: 5px;
    color: ${props => props.theme.color.red};

    span {
      display: inline-block;
      margin-left: 3px;
      text-decoration: none;
    }
  }

  span {
    font-size: 15px;
    color: #747474;
    margin-left: 5px;
    letter-spacing: -0.28px;
    text-decoration: line-through;
    display: inline-block;
    position: relative;
    font-family: Roboto-Medium;
  }

  @media screen and (min-width: 1100px) {
    p,
    .price-icon {
      font-size: 21px;
    }

    span {
      font-size: 16px;
    }

    .out-of-stock {
      font-size: 15px;
      padding-bottom: 6px;
    }

    @media screen and (max-width: 1399px) {
      .out-of-stock {
        padding-top: 2px;
        font-size: 13px;
        padding-bottom: 6px;
      }
    }
    @media screen and (max-width: 1249px) {
      .out-of-stock {
        padding-top: 8px;
        font-size: 11px;
        padding-bottom: 6px;
      }
    }
  }
`

export const FreshItemPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 7px;
  width: 40%;

  img {
    margin-right: 6px;
  }

  .out-of-stock {
    font-size: 15px;
  }

  p,
  .price-icon {
    font-size: 18px;
    font-weight: bold;
    font-family: ${props => props.theme.font.family.medium};
    margin-right: 4px;
    border-radius: 5px;
    color: #eb3e3e;

    span {
      display: inline-block;
      margin-left: 3px;
      text-decoration: none;
    }
  }

  span {
    font-size: 13px;
    color: #747474;
    letter-spacing: -0.28px;
    text-decoration: line-through;
    display: inline-block;
    position: relative;
    font-family: ${props => props.theme.font.family.medium};
  }

  @media screen and (min-width: 1100px) {
    p,
    .price-icon {
      font-size: 21px;
    }

    span {
      font-size: 16px;
    }
  }
`

export const ItemImage = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  img {
    display: block;
    position: absolute;
    width: 12rem;
    max-height: 100%;
    transition: opacity 0.4s ease-in-out;
  }

  @media screen and (min-width: 1100px) {
    img {
      width: 130px;
    }

    &.hovered {
      .second-image {
        opacity: 0;
      }

      &:hover {
        img {
          opacity: 0;
        }

        .second-image {
          opacity: 1;
        }
      }
    }
  }
`

export const ItemName = styled.h2`
  color: ${props => props.theme.color[props.color]};
  font-family: ${props => props.theme.font.family.regular};
  font-size: 13px;
  margin-top: 7px;
  font-weight: lighter;
  overflow: hidden;
  height: 70px;
  -webkit-box-orient: vertical;
  transition: 0.3s;
  margin-bottom: 0;
  @media screen and (min-width: 1100px) {
    margin-top: 10px;
    font-size: 15px;
  }
`

export const ItemFavorite = styled.div`
  position: absolute;
  top: 20px;
  right: 15px;
  z-index: 99;
  cursor: pointer;

  svg {
    width: 14.48px;
    height: 12.54px;
  }

  @media screen and (min-width: 1100px) {
    right: 20px;
    svg {
      width: unset;
      height: unset;
    }
  }
`

export const AddFavoriteButton = styled(Button)`
  margin-top: 15px;
  position: absolute;
  z-index: 100;
  opacity: 0;
  transition: 0.3s;
  @media screen and (min-width: 1100px) {
  }
`

export const ProductItemContainer = styled(Link)`
  background-color: ${props => props.theme.color.white};
  text-decoration: none;
  border-radius: 6px;
  box-shadow: 0 3px 15px 0 rgba(219, 212, 212, 0.15);
  border: 1px solid ${props => props.theme.color.greyED};
  ${props =>
    props.istop ? `border: 1px solid ${props.theme.color.orange}` : ''}
  display: flex;
  flex-direction: column;
  padding: 5px;
  position: relative;
  transition: 0.3s;
  height: fit-content;

  ${props =>
    props['data-nostock'] &&
    `
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
    // opacity: 0.6;
  `}

  @media screen and (min-width: 1100px) {
    padding: 20px 10px 5px 10px;
  }

  @media screen and (min-width: 1100px) {
    ${props =>
      !props.nohover &&
      '&:hover { transform: scale(1.1, 1.1); transition: 0.3s;}'}
  }
  .product-item {
    position: relative;
    overflow: hidden;
    z-index: 10;
  }

  .mobile-cart-container {
    display: flex;
    align-items: center;
    align-self: flex-end;
    padding: 8px;
    border-radius: 4px;
    background: #f2f4f5;
    font-size: 12px;
    margin-bottom: 6px;
    margin-top: 4px;
    color: black;
    gap: 5px;
  }

  .mobile-buy-container {
    display: flex;
    align-items: center;
    align-self: flex-end;
    padding: 8px;
    border-radius: 4px;
    background: linear-gradient(
      to right top,
      #ff4b2b,
      #ff453e,
      #ff424e,
      #ff405d,
      #ff416c
    );
    font-size: 12px;
    margin-bottom: 6px;
    margin-top: 4px;
    color: white;
    gap: 5px;
  }
  .cart-container {
    position: absolute;
    right: -10px;
    top: 10%;
    transition: all 0.3s ease;
    opacity: 0;
    display: flex;
    background-color: gainsboro;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
  }

  &:hover .cart-container {
    right: 10px;
    opacity: 1;
    pointer-events: auto;
    z-index: 999;
  }
  .stars-and-name {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`

export const TopCircle = styled.div`
  width: 39px;
  height: 39px;
  border-radius: 100%;
  background-color: ${props => props.theme.color.orange};
  color: white;
  font-size: 12px;
  text-align: center;
  line-height: 39px;
  text-transform: uppercase;

  position: absolute;
  left: 16px;
  top: 16px;
  z-index: 10;
`

const shadowMd =
  '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
const shadowLg =
  '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
const ringColor = '#FF4061'
const ringOffsetColor = '#FFFFFF'

export const ColorOption = styled.div.attrs(props => ({
  style: {
    backgroundColor: props.color,
  },
}))`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  box-shadow: ${props =>
    props.isActive
      ? `${shadowLg}, 0 0 0 2px ${ringOffsetColor}, 0 0 0 3px ${ringColor}`
      : shadowMd};

  &:hover {
    transform: scale(1.1);
    box-shadow: ${props =>
      props.isActive
        ? `${shadowLg}, 0 0 0 2px ${ringOffsetColor}, 0 0 0 3px ${ringColor}`
        : shadowLg};
  }

  &:active {
    transform: scale(0.95);
  }

  ${({ isActive }) =>
    isActive &&
    `
      box-shadow: ${shadowLg}, 0 0 0 2px ${ringOffsetColor}, 0 0 0 3px ${ringColor};
    `}
`
